import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import service from '../services/service';
export default {
  name: 'record',
  data: function data() {
    return {
      list: []
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var defaultList, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              defaultList = [{
                "eggType": 1,
                "friendsType": 1,
                "goodsName": "亚朵酒店596元礼包",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/C8AF3B8875DE437152ACC4CFED56D8771544525996/0",
                "nickName": "萱萱",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=XeIvTaqrYH6sS8tpoVbbDw&s=140&t=1483332573"
              }, {
                "eggType": 3,
                "friendsType": 1,
                "goodsName": "2.6元现金红包",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/03451C3303FA0A3AA20D8C0E64EA1CBF1544935713/0",
                "nickName": "..亻圭",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=C7OTeXQbTxvaHlfFibJqlUg&s=140&t=1483315628"
              }, {
                "eggType": 3,
                "friendsType": 1,
                "goodsName": "0.6元现金红包",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/669078B5F4A40DA4CF0FFD46EBE541681544786044/0",
                "nickName": "浩佳",
                "nickUrl": "//thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLCneiaPrKibeUaDTqjWBHf2via6Oy2VzMOfy5CibKdgzvX5zMiaeoWcWeuFiaIXLkr89B55ialwNhIeEfibQ/132"
              }, {
                "eggType": 1,
                "friendsType": 2,
                "goodsName": "同程旅游出行礼包",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/55E4B5BA1342F64CF13A91A743EFBF561544529368/0",
                "nickName": "WWWWWWWWWWWWWWWWWWWWWWWWWWW",
                "nickUrl": "//thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIPN0vfTWqUriaTFp0ylCabpsSX5sytzuezWibkx8avYDWs8BCPeKKoNDuDsForXLetOx4Up77aGpEg/132"
              }, {
                "eggType": 1,
                "friendsType": 2,
                "goodsName": "车主无忧50元加油金",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/8C3532A93C239E85F6528F3AB1E9BBE51544525949/0",
                "nickName": "WWWWWWWWWWWWWWWWWWWWWWWWWWW",
                "nickUrl": "//thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIPN0vfTWqUriaTFp0ylCabpsSX5sytzuezWibkx8avYDWs8BCPeKKoNDuDsForXLetOx4Up77aGpEg/132"
              }, {
                "eggType": 1,
                "friendsType": 2,
                "goodsName": "京东读书免费优质电子书",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/15766D7A591AFEFC33EC3AA264F2774A1544526947/0",
                "nickName": "rdgztest_81383",
                "nickUrl": "/0"
              }, {
                "eggType": 2,
                "friendsType": 2,
                "goodsName": "亚朵酒店596元礼包",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/C8AF3B8875DE437152ACC4CFED56D8771544528927/0",
                "nickName": "追风筝的人",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=tnS2uicibpMmqicnrqP3dHM5A&s=140&t=1486781091"
              }, {
                "eggType": 3,
                "friendsType": 2,
                "goodsName": "维乐口腔价值650元洁牙卡",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/60FB1427B64D0B9AD528CC06CD8D99741544526908/0",
                "nickName": "小哥",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=sNxCibkRGFIZC71ricXYv3Rw&s=140&t=1483330137"
              }, {
                "eggType": 3,
                "friendsType": 1,
                "goodsName": "0.6元现金红包",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/669078B5F4A40DA4CF0FFD46EBE541681544786044/0",
                "nickName": "lisa爱吃周黑鸭",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=9uSQ6qiaxWicjtO8xHlrF7Dw&s=100&t=528"
              }, {
                "eggType": 2,
                "friendsType": 2,
                "goodsName": "喜马拉雅15天会员体验",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/56F593FA0CD810B2B171E266B6A5370C1544529203/0",
                "nickName": "追风筝的人",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=tnS2uicibpMmqicnrqP3dHM5A&s=140&t=1486781091"
              }, {
                "eggType": 3,
                "friendsType": 1,
                "goodsName": "贝瓦儿歌VIP会员15天",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/DC654B6DB2C871130BB5E154D5F9A2651544524010/0",
                "nickName": "存在",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=EcHkicibZib4dxKLWVyYmz14Q&s=100&t=546"
              }, {
                "eggType": 1,
                "friendsType": 1,
                "goodsName": "航班管家185元出行礼包",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/1A22DB4133977C79F56126B34601F0DF1544525792/0",
                "nickName": "rdgztest_81383",
                "nickUrl": "/0"
              }, {
                "eggType": 3,
                "friendsType": 1,
                "goodsName": "返利网0元购保温杯",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/07F959BCDCBCBC78A1F9A15BD11732CD1544524171/0",
                "nickName": "存在",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=EcHkicibZib4dxKLWVyYmz14Q&s=100&t=546"
              }, {
                "eggType": 2,
                "friendsType": 1,
                "goodsName": "炫技运动蓝牙耳机100元优惠券",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/DFACD2BE5BA121899938C778CA308B6F1544524887/0",
                "nickName": "JayChen",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=RAjOuh3uGj8XXbzNQpGRdw&s=100&t=555"
              }, {
                "eggType": 2,
                "friendsType": 2,
                "goodsName": "维乐口腔价值650元洁牙卡",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/60FB1427B64D0B9AD528CC06CD8D99741544526908/0",
                "nickName": "JayChen",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=RAjOuh3uGj8XXbzNQpGRdw&s=100&t=555"
              }, {
                "eggType": 2,
                "friendsType": 2,
                "goodsName": "漫步者耳机100元优惠券",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/6F842D454B80658B8711AFC3C63FCEAA1544524829/0",
                "nickName": "JayChen",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=RAjOuh3uGj8XXbzNQpGRdw&s=100&t=555"
              }, {
                "eggType": 3,
                "friendsType": 2,
                "goodsName": "喜马拉雅15天会员体验",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/56F593FA0CD810B2B171E266B6A5370C1544529061/0",
                "nickName": "Void",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=bNu6OVu7MVtDjRwgCl24Ow&s=100&t=1506682142"
              }, {
                "eggType": 3,
                "friendsType": 2,
                "goodsName": "5EPLAY免费会员月卡",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/D242FE0BA56BD4532B61130D3BB8618F1544524078/0",
                "nickName": "Void",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=bNu6OVu7MVtDjRwgCl24Ow&s=100&t=1506682142"
              }, {
                "eggType": 3,
                "friendsType": 2,
                "goodsName": "爱回收888元大礼包",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/37FC17DF2AD7586001A63DD6D0B33B691544529173/0",
                "nickName": "Void",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=bNu6OVu7MVtDjRwgCl24Ow&s=100&t=1506682142"
              }, {
                "eggType": 3,
                "friendsType": 2,
                "goodsName": "0.6元现金红包",
                "goodsUrl": "//puui.qpic.cn/vshpic/0/669078B5F4A40DA4CF0FFD46EBE541681544786044/0",
                "nickName": "Void",
                "nickUrl": "//thirdqq.qlogo.cn/g?b=sdk&k=bNu6OVu7MVtDjRwgCl24Ow&s=100&t=1506682142"
              }];
              _context.prev = 1;
              _context.next = 4;
              return service.getRecord();

            case 4:
              res = _context.sent;

              if (res.ret === 0) {
                this.list = res.list;
              } else {
                this.list = defaultList;
              }

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              window.console.error(_context.t0);
              this.list = defaultList;

            case 12:
              setTimeout(function () {
                new window.Swiper('.record.swiper-container', {
                  autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: true
                  }
                });
              }, 0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 8]]);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }()
};